export class QNPIdReq {
    qnpId: number;
    otp: string;

    constructor(qnpId: number) {
        this.qnpId = qnpId;
    }
}